<template>
  <div>

    <v-row>
      <v-btn :text="view !== 0" @click="view = 0">
        Raw
      </v-btn>
      <v-btn :text="view !== 1" @click="view = 1">
        Visual
      </v-btn>
    </v-row>

    <div v-if="view === 0">
      <json-viewer :item="localSchema"></json-viewer>

      <v-card class="ma-2 pa-4">
        SELECT * FROM corexdb.inventory_definitions WHERE JSON_CONTAINS(json_schema, 'false', '$.key_1');
      </v-card>
    </div>

    <div v-else-if="view === 1">

      <list-row v-for="key of Object.keys(localSchema)" :key="key" :v_key="key" :v_value.sync="localSchema[key]" :v_type="schema_template[key].type" :v_name="schema_template[key].name">
      </list-row>

    </div>

    <v-row>
      <v-btn @click="save">
        Save
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import ListRow from './row'
import JsonViewer from '@/components/toolbox/json-viewer/Main'
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'

export default {
  props: {
    schema: null,
    inventory_item_id: null
  },
  components: {
    ListRow,
    JsonViewer
  },
  data () {
    return {
      view: 1,
      saving: false,
      schema_template: null,
      localSchema: {}
    }
  },
  watch: {
    schema () {
      this.loadAPI()
    }
  },
  methods: {
    addItem () {
      var i = 1
      while (true) {
        if (!this.schema.hasOwnProperty(`key_${i}`)){
          console.log('breaking')
          break
        }
        i++
      }
      Vue.set(this.schema, `key_${i}`, {
        type: 'boolean',
        default: false,
        name: 'Cosmos Organic'
      })
    },
    save () {
      return new Promise((resolve, reject) => {
        let data = {
          schema: this.localSchema
        }
        this.saving = true
        this.$axios.patch(`inventory-definitions/${this.inventory_item_id}/schema`,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            this.loadAPI()
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    },
    loadAPI () {
      this.schema_template = JSON.parse(this.$store.state.settings.dict[STATIC_SETTINGS.INVENTORY_DEFINITION_SCHEMA]) || {}
      var localSchema = {}
      // schema must at least be an object
      var schema = this.schema
      if (! _.isObject(schema)) {
        schema = {}
      }
      for (var key of Object.keys(this.schema_template)) {
        // const {_default, ...documentWithoutDefault} = this.schema_template[key]
        // schema[key] = JSON.parse(JSON.stringify(documentWithoutDefault))
        if (schema.hasOwnProperty(key)) {
          var value = schema[key]
          if (typeof value === this.schema_template[key].type) {
          }
        } else {
          schema[key] = this.schema_template[key]._default
        }
      }
      this.localSchema = schema
    }
  },
  created () {
    this.loadAPI()
  }
}
</script>